import {LOCALES} from "utils/languageUtils";

/** @type {Readonly<Record<LOCALES.ENGLISH | LOCALES.GREEK, Record<string, string>>>} */
const NOT_FOUND_PAGE_LABELS = Object.freeze({
    [LOCALES.ENGLISH]: {
        pageTitle: 'Page not found!',
        pageContent: 'The requested page was not found.',
    },
    [LOCALES.GREEK]: {
        pageTitle: 'Η σελίδα δεν βρέθηκε!',
        pageContent: 'Η σελίδα που ζητήθηκε δεν βρέθηκε.',
    }
});
export default NOT_FOUND_PAGE_LABELS;